import { defineComponent as _defineComponent } from 'vue'
import {
  ref, watch, computed, useSlots,
} from 'vue';
import SRichTextEditor from '@/components/SRichTextEditor.vue';
import SRichTextViewer from '@/components/SRichTextViewer.vue';

interface InputDescriptionEditProps {
  description: string | null;
  readonly: boolean;
  urn?: string;
}
type InputDescriptionEditEmits = {
  (event: 'save', value: string | null): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Input-Description-Edit',
  props: {
  description: { default: null },
  readonly: { type: Boolean, default: false },
  urn: { default: '' }
},
  emits: ["save"],
  setup(__props, { emit }) {

const props = __props;





const descriptionModel = ref<string>('');
const editMode = ref(false);
const slots = useSlots();

// TODO: Should add !props.urn.readonly, but urn is not properly typed yet
const canEdit = computed(() => !editMode.value && !props.readonly);

const loading = computed(() => props.description === null);
const hasDescription = computed(() => props.description && !editMode.value);
const hasSlot = computed(() => Object.keys(slots).length);
const hasNone = computed(() => {
  if (hasSlot.value) return false;
  return !props.description && !editMode.value;
});

/**
 * Enter edit mode
 */
function enterEditMode() {
  editMode.value = true;
  descriptionModel.value = props.description ?? '';
}

/**
 * Exit edit mode
 */
function exitEditMode() {
  editMode.value = false;
}

/**
 * Save description
 */
function save() {
  emit('save', descriptionModel.value);
  exitEditMode();
}

watch(() => props.urn, exitEditMode);

return { __sfc: true,props, emit, descriptionModel, editMode, slots, canEdit, loading, hasDescription, hasSlot, hasNone, enterEditMode, exitEditMode, save, ref, watch, computed, useSlots, SRichTextEditor, SRichTextViewer }
}

})